import React, {useState} from "react";
import autosureLogo from '../images/autosure-logo.png';
import {Container} from "react-bootstrap";

const HeaderTFAF = (props) => {

  const [showRecaptcha, setShowRecaptcha] = useState(false);
    return (

        <>

          <div style={{
                width: '100%',
                height: '100%',
                paddingTop: 20,
                background: 'white',
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.06)',
                justifyContent: 'space-between',
                alignItems: 'center',
                display: 'inline-flex'
            }}>
                <Container>
                    <center><img src={autosureLogo} alt="autosureLogo"/></center>
                    <br/>
                </Container>
            </div>

        </>

    );
}

export default HeaderTFAF;
